
import React from 'react';
import { TabsContent } from '@/components/ui/tabs';
import NewsGrid from './NewsGrid';
import NewsFeaturedArticle from './NewsFeaturedArticle';
import SavedArticlesContent from './SavedArticlesContent';
import { NewsArticle } from '@/types/news';

interface NewsTabContentProps {
  tabValue: string;
  isLoading: boolean;
  isError: boolean;
  articles: NewsArticle[];
  totalArticles: number;
  page: number;
  itemsPerPage: number;
  onLoadMore: () => void;
}

const NewsTabContent: React.FC<NewsTabContentProps> = ({
  tabValue,
  isLoading,
  isError,
  articles,
  totalArticles,
  page,
  itemsPerPage,
  onLoadMore
}) => {
  if (tabValue === 'saved') {
    return (
      <TabsContent value={tabValue} className="space-y-8 mt-0">
        <SavedArticlesContent />
      </TabsContent>
    );
  }

  const shouldShowFeatured = tabValue === 'all' && page === 1 && articles && articles.length > 0;
  const displayArticles = shouldShowFeatured ? articles.slice(1) : articles;
  const featuredArticle = shouldShowFeatured ? articles[0] : undefined;

  return (
    <TabsContent value={tabValue} className="space-y-8 mt-0">
      {shouldShowFeatured && (
        <div className="mb-8">
          <NewsFeaturedArticle 
            isLoading={isLoading} 
            isError={isError} 
            article={featuredArticle} 
          />
        </div>
      )}
      <NewsGrid 
        isLoading={isLoading}
        isError={isError}
        articles={displayArticles || []}
        onLoadMore={onLoadMore}
        totalArticles={totalArticles}
        currentPage={page}
        itemsPerPage={itemsPerPage}
      />
    </TabsContent>
  );
};

export default NewsTabContent;
